import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: TheManuz
 * id 6B63F864-415A-4679-9126-363E5254B175
 * name cash-register
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cash-register.svg
 * tags
 * - Shopping 
 * - Banking 
 */
export const CashRegisterIcon = createSvgIcon(<><path d="M2,17H22V21H2V17M6.25,7H9V6H6V3H14V6H11V7H17.8C18.8,7 19.8,8 20,9L20.5,16H3.5L4.05,9C4.05,8 5.05,7 6.25,7M13,9V11H18V9H13M6,9V10H8V9H6M9,9V10H11V9H9M6,11V12H8V11H6M9,11V12H11V11H9M6,13V14H8V13H6M9,13V14H11V13H9M7,4V5H13V4H7Z" /></>, 'CashRegisterIcon');
export default CashRegisterIcon